<template>
    <div>
        <button @click="click">
			<img :src="buttonImage" alt="Back" />
		</button>
    </div>
</template>

<script>
export default {
	name: 'BackButton',
	props: ['isLessonDetail'],
	computed: {
		buttonImage: function() {
			if (this.isLessonDetail) {
				return "./assets/images/back_button.svg";
			} else {
				return "./assets/images/back.svg";
			}
		},
	},
	methods: {
		// ボタンクリック
		click() {
			if (this.isLessonDetail) {
				let backTo = this.$store.state.backTo;
				if (backTo == '') {
					this.$router.back();
				} else {
					this.$router.push({ name: backTo });
				}
			} else {
				this.$router.back();
			}
		},
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
button {
	position: absolute;
	top: 0;
	left: 0;
	z-index: 100;
	width: 40px;
	height: 40px;
	background: transparent;
	border: 0;
	padding: 8px;
}
</style>